import { makeAutoObservable, action } from 'mobx'
import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { ChatbotInstructionType, type ChatbotInstructions } from 'entities/Chatbot'
import { requestTextingAgentEnhance } from 'entities/AIAgent/Texting/helpers/requestTextingAgentEnhance'
import { InstructionsSectionContent } from '../InstructionsSectionContent'

export class InstructionsSectionStore {
  error = ''
  private _snapshot = ''

  constructor(
    readonly entities: IEntitiesStore,
    private _agentId: number | null,
    private _instructions: ChatbotInstructions
  ) {
    makeAutoObservable(this)
  }

  get instructions() {
    return this._instructions.instructions
  }

  setInstructions = (value: string) => {
    this._instructions.setInstructions(value)
    this.error = ''
  }

  setError = (value: string) => {
    this.error = value
  }

  resetInstructions = () => {
    this._instructions.setInstructions('')
    this.error = ''
  }

  get requestEnhance() {
    return requestTextingAgentEnhance(this.entities, {
      chatbotType: ChatbotInstructionType.Unified,
      usesKnowledgeBase: false,
      chatbotId: this._agentId ?? 0,
    })
  }

  openModal = () => {
    const modalId = nanoid()
    this._snapshot = this._instructions.instructions

    const handleCancel = action(() => {
      this._instructions.setInstructions(this._snapshot)
      this.error = ''
      modalStore.removeModal(modalId)
    })

    const handleSave = () => {
      modalStore.removeModal(modalId)
    }

    modalStore.addModal({
      id: modalId,
      title: 'Edit',
      width: 800,
      paddingContent: '0 24px 8px',
      onClose: handleCancel,
      primaryAction: {
        text: 'Save',
        onAction: handleSave,
      },
      ModalContent: InstructionsSectionContent,
      ModalContentProps: {
        store: this,
        isExpanded: true,
      },
    })
  }
}
